module.exports = "<router-outlet></router-outlet>\n<app-loader></app-loader>\n<app-error-handler></app-error-handler>"